import React, { useEffect, useState } from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
};

export interface SelectProps {
  options: Option[];
  value?: Option; // ✅ Accept controlled value
  defaultValue?: Option;
  className?: string;
  styles?: any;
  onChange?: (option: Option | null) => void;
  disabled?: boolean;
}

const CommonSelect: React.FC<SelectProps> = ({
  options,
  value,
  defaultValue,
  className,
  styles,
  onChange,
  disabled,
}) => {
  const [selectedOption, setSelectedOption] = useState<Option | undefined>(
    defaultValue
  );

  const handleChange = (option: Option | null) => {
    setSelectedOption(option || undefined);
    onChange?.(option || null); // ✅ Trigger parent onChange
  };

  useEffect(() => {
    if (value !== undefined) {
      setSelectedOption(value); // ✅ Update from controlled prop
    } else if (defaultValue !== undefined) {
      setSelectedOption(defaultValue);
    }
  }, [value, defaultValue]);

  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      styles={styles}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      placeholder="Select"
      isDisabled={disabled}
    />
  );
};

export default CommonSelect;
